/**
 * Reach card under the size picker (blocks/pdp-reach-bar.liquid): updates the bar, the
 * reach text and the "next size" tip instantly when the size changes, and the tip
 * button switches to the suggested size. Works on the PDP and in the quick-buy modal
 * (whose HTML is inserted later, so inline scripts there would never run).
 */
(function () {
  if (window.__pdpReachInit) return;
  window.__pdpReachInit = true;

  var STEPS = { '1ml': 1, '2ml': 2, '3ml': 3, '5ml': 4, '10ml': 5 };
  var REACH = { '1ml': 'ca. 3 Tage', '2ml': 'ca. 1 Woche', '3ml': 'ca. 10 Tage', '5ml': 'ca. 2½ Wochen', '10ml': 'ca. 1 Monat' };
  var NEXT = { '1ml': '3ml', '2ml': '3ml', '3ml': '5ml', '5ml': '10ml' };
  var money = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  var label = function (s) { return s.replace('ml', ' ml'); };

  function scopeOf(el) {
    return el.closest('dialog, .quick-add-modal, .product-information, .shopify-section') || document;
  }

  function update(card, size) {
    if (!card || !STEPS[size]) return;
    card.querySelectorAll('.pdp-reach__bar i').forEach(function (i, k) { i.classList.toggle('on', k < STEPS[size]); });
    var text = card.querySelector('[data-reach-text]');
    if (text) text.textContent = REACH[size];

    var tip = card.querySelector('[data-reach-tip]');
    var prices = {};
    try { prices = JSON.parse(card.querySelector('[data-reach-prices]').textContent); } catch (e) {}
    var target = NEXT[size];
    if (!tip || !target || !prices[target] || !prices[target].available || !prices[size]) {
      if (tip) tip.hidden = true;
      return;
    }
    var extra = target === '3ml' ? ' – unsere Empfehlung,' : target === '10ml' ? ' – bester Preis pro ml,' : ' –';
    tip.querySelector('[data-reach-tip-text]').innerHTML =
      '<span class="pdp-reach-tip__label">Tipp</span>' + label(target) + ' reicht <strong>' + REACH[target] + '</strong>' + extra +
      ' nur ' + money.format((prices[target].price - prices[size].price) / 100) + ' mehr.';
    var btn = tip.querySelector('[data-reach-tip-button]');
    btn.dataset.size = target;
    btn.textContent = 'Auf ' + label(target) + ' wechseln';
    tip.hidden = false;
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('variant-picker input[type="radio"]')) return;
    var size = String(t.value || '').toLowerCase().replace(/\s+/g, '');
    update(scopeOf(t).querySelector('[data-reach-card]'), size);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-reach-tip-button]');
    if (!btn) return;
    var scope = scopeOf(btn);
    var input = Array.prototype.find.call(scope.querySelectorAll('variant-picker input[type="radio"]'), function (i) {
      return String(i.value).toLowerCase().replace(/\s+/g, '') === btn.dataset.size;
    });
    if (input) input.click();
  });
})();
